import { render, staticRenderFns } from "./DemandReview.vue?vue&type=template&id=af496266"
import script from "./DemandReview.vue?vue&type=script&lang=js"
export * from "./DemandReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af496266')) {
      api.createRecord('af496266', component.options)
    } else {
      api.reload('af496266', component.options)
    }
    module.hot.accept("./DemandReview.vue?vue&type=template&id=af496266", function () {
      api.rerender('af496266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/RecruitManage/Demand/DemandReview.vue"
export default component.exports